import ConfigurationInterface from "./configuration_interface";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import http from "../../http";
import { Configuration } from "../../../../domain/entities/configuration";

class ConfigRepository implements ConfigurationInterface {
  async get(): Promise<Configuration> {
    return wrapErrorHandler<Configuration>(async () => {
      const response = await http.get(`/api/decola/configuration`);
      const config: Configuration = response.data;
      localStorage.setItem('configuration', JSON.stringify(config));
      return config;
    });
  }

}

export default new ConfigRepository() as ConfigurationInterface;
